import { Chip } from '@mui/material'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import { TextInput } from 'src/components'
import { useStepImpactsSelection } from 'src/hooks'
import { ETranslationNs, IScanCreateForm } from 'src/types'
import { ImpactsAssociationInput } from './impact-association.component'
import { useStyles } from '../styles'

export const ImpactRecord = () => {
  const [t] = useTranslation(ETranslationNs.ScanForm)
  const classes = useStyles()
  const { values, handleChange, errors, setFieldValue } = useFormikContext<IScanCreateForm>()

  const setSelectedImpact = (id: string | null) => {
    if (!id) {
      setFieldValue('impact_quantity', null)
    }

    setFieldValue('impact_id', id)
  }
  const { handleSelectedImpact, selectedImpacts } = useStepImpactsSelection({
    selectedImpact: values.impact_id,
    setSelectedImpact,
    stepId: values.step_id,
  })

  const selectedItems = values.impact_id ? [values.impact_id] : []
  const impact = selectedImpacts[0]
  const isImpactMeasurable = impact && (impact.quantity_type || impact.custom_quantity_type)
  return (
    <>
      <ImpactsAssociationInput
        error={errors.impact_id}
        step_id={values.step_id}
        selectedItems={selectedItems}
        selectedImpactsIcons={selectedImpacts}
        handleSelectedImpact={handleSelectedImpact}
      />
      {isImpactMeasurable && (
        <div className={classes.impactWrapper}>
          <TextInput
            fullWidth
            inputName="impact_quantity"
            handleChange={handleChange}
            value={values.impact_quantity ? String(values.impact_quantity) : undefined}
            error={errors.impact_quantity}
            inputUpperLabel={t('scan-form-quantity-input-label.v') + '*'}
            inputPlaceholder={t('scan-form-quantity-input-placeholder.v')}
          />
          <Chip
            label={
              selectedImpacts[0].quantity_type?.name || selectedImpacts[0].custom_quantity_type
            }
            variant="outlined"
          />
        </div>
      )}
    </>
  )
}
